import { shopPrefix } from '../../config';
import { http } from '../axios';
import { AddSingleProductRequest } from './addSingleProductToCart';

type Options = {
    productId: string;
    body: AddSingleProductRequest;
};

const url = `${shopPrefix}/v2/shoppingcart/products/:productId/decrease`;

export const decreaseAmountSingleProductInCart = ({ body, productId }: Options) => {
    return http
        .put<void>(url, body, {
            pathParams: {
                productId
            }
        })
        .then(res => res.data);
};
